import UltMeta, { Meta } from "@/meta/UltMeta/index";

class PlatBankAccountState extends UltMeta {
    DIASABLE = new Meta(0, "禁用");
    ENABLED = new Meta(1, "启用");
}

export const PLAT_BANK_ACCOUNT_STATE = new PlatBankAccountState();
